// Note:
// _menu: nếu là các menu
// _act: nếu là các action của button, ...

export const GlobalPolcies = {
  // Lef menu quan ly perrmission
  systemManagement: {
    left_menu: {
      permisionManagement: '5001', //web: menu left - Quản trị hệ thống - Phân quyền
    },
  },
  default: {
    left_menu: {
      tai_khoan: '6', //web: menu left - Tài khoản
    },
  },
  ioiort_cap_treo: {
    // tag: cap-treo-fansipan
    left_menu: {
      //
      dat_ve: '1', // web: menu left - Ioiort Cáp Treo - Đặt vé
      quan_ly_don_hang: '2', // web: menu left - Ioiort Cáp Treo - Quản lý đơn hàng
      //  bao_cao: '3', // web: menu left - Ioiort Cáp Treo - Báo cáo
      cai_dat_ve: '4', // web: menu left - Ioiort Cáp Treo - Cài đặt vé
      cai_dat_nhom_ve: '5', // web: menu left - Ioiort Cáp Treo - Cài đặt nhóm vé,
      sync_data: '7', // web: menu left - Ioiort Cáp Treo - Sync data
      quan_ly_dai_ly: '8', // web: menu left - Ioiort Cáp Treo - Quản lý đại lý
      ve_ban_lai: '9', // web: menu left - Ioiort Cáp Treo - Vé bán lại
      bao_cao_ton_kho: '10', // web: menu left - Ioiort Cáp Treo - Báo cáo tồn kho
      bao_cao_doanh_thu: '11', // web: menu left - Ioiort Cáp Treo - Báo cáo doanh thu
      vi_tien: '12', // web: menu left - Ioiort Cáp Treo - Ví tiền
    },
  },
};
